// AUTO-GENERATED - DO NOT EDIT MANUALLY

import {
  DailyRewardOpenResultDto,
  DailyRewardStateDto,
  IBaseSingleResultDto,
} from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class DailyRewardService {
  /**
   * GET /api/daily-rewards
   */
  getState(
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<DailyRewardStateDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/daily-rewards';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/daily-rewards/open
   */
  open(
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<DailyRewardOpenResultDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/daily-rewards/open';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
